import { render, staticRenderFns } from "./LeaveReview.vue?vue&type=template&id=0c7674e4"
import script from "./LeaveReview.vue?vue&type=script&lang=js"
export * from "./LeaveReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports